import "./IconGear.scss";
import { ReactComponent as Icon } from "./svg/icon_gear.svg";

export interface Props {
  className?: string;
  noBorder?: boolean;
}
export const IconGear = ({ className, noBorder = false }: Props) => {
  const noBorderClass = noBorder ? "icon-gear--no-border" : "";
  return (
    <span className={`icon-gear ${noBorderClass} ${className ? `icon-gear__${className}` : ""}`}>
      <Icon />
    </span>
  );
};
